<template>
  <div class="options">
    <div class="options-list">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Options',
  props: {
    options: Array
  },
  methods: {
    selectValueHandler(value) {
      this.$emit('select', value)
    }
  }
}
</script>
